
/**  Donate Formie Tab Controller */
document.addEventListener('onFormieInit', (event) => {
        let Formie = event.detail.formie;
        let $form = document.querySelector(".donateForm");
        if($form){
                let form = Formie.getForm($form);
                let submitHandler = null;
                let finalDonationInput = $form.querySelector('input[name="fields[donationAmount]"]')

                $form.addEventListener('onBeforeFormieSubmit', (e)=>{
                    submitHandler = e.detail.submitHandler;
                });
                $form.addEventListener('onAfterFormieSubmit', (e) => {
                    let formData = new FormData($form);
                    // Handle Final Donation Amount
                    let hasCustomDonationChecked = formData.getAll("fields[customDonationAmount]")[1] == 1 ?? false;
                    let seletedDonationAmount = formData.get("fields[selectdonationAmount]");
                    let inputDonationAmount =  formData.get("fields[inputDonationAmount]");
                    if(finalDonationInput && hasCustomDonationChecked){
                        finalDonationInput.value = inputDonationAmount;
                    }else{
                        finalDonationInput.value = seletedDonationAmount
                    }
                });
        }
});
